<template>
  <div class="header-banner">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(image, index) in images" :key="index">
        <img :src="image" alt="Banner" class="banner-image" />
      </swiper-slide>
      <template #pagination>
        <div class="swiper-pagination"></div>
      </template>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';

export default {
  name: 'HeaderBanner',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      images: [
        require('@/assets/banner1.png'),
        require('@/assets/banner2.png'),
        require('@/assets/banner3.png'),
      ],
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
        loop: true,
      },
    };
  },
};
</script>

<style scoped>
.header-banner {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>